/*
 * @Description: 
 * @Date: 2023-11-16 09:56:13
 * @Author: songjian
 * @LastEditors: songjian
 * @LastEditTime: 2024-06-03 18:50:00
 * @FilePath: /海通PC/config/config.js
 */
var url;
if (process.env.EVN_CONFIG == 'ali') {
	url = {
		otcurl: "https://bh.httest.cairenhui.com/otc/",
		riskurl: 'https://bh.httest.cairenhui.com/risk/',
		digitalurl: 'https://bh.httest.cairenhui.com/digital/',
		open_fund: 'https://bh.httest.cairenhui.com/open_fund/'
	}
} else if (process.env.EVN_CONFIG == 'zb') {
	url = {
		otcurl: "https://obs.httest.com/otc/",
		riskurl: 'https://obs.httest.com/risk/',
		digitalurl: 'https://obs.httest.com/digital/',
		open_fund: 'https://obs.httest.com/open_fund/'
	}
} else {
	url = {
		otcurl: "https://bh.htsec.com/otc/",
		riskurl: 'https://bh.htsec.com/risk/',
		digitalurl: 'https://bh.htsec.com/digital/',
		open_fund: 'https://bh.htsec.com/open_fund/'
	}
}

module.exports = {
	apiUrl: process.env.APIURL,
	serverUrl: process.env.SERVERURL,
	infoServerPath:process.env.INFOSERVERPATH,
	url: url,
	global: {
		//交易市场标志:    "0":沪A	"1":深A   "2":沪B   "3":深B   "5":三板A   "6":三板B   "7":三板B(特别转让)   "8":港股通   "9":OTC  "A":客户号   "J":基金账号
		market_code: ['0', '1', '2', '3', '5', '6', '7', '8', '9', 'A', 'J'],
		SALEOUTHQ: true,
		entrust_type: ['99', '100', '101', '102'],
		"net_cate": "1",//登录的字段--网络种类
		// 开发环境
		// netUrl:
		// 	['https://bh.httest.cairenhui.com/otc/',
		// 		'https://bh.httest.cairenhui.com/risk/',
		// 		'https://bh.httest.cairenhui.com/digital/',
		// 		'https://bh.httest.cairenhui.com/open_fund/'],
		// 质保环境
		// netUrl:
		// 	['https://obs.httest.com/otc/',
		// 		'https://obs.httest.com/risk/',
		// 		'https://obs.httest.com/digital/',
		// 		'https://obs.httest.com/open_fund/'],
		// 质保环境
		// netUrl:
		// 	['http://120.86.70.44:18080/otc/',
		// 		'http://120.86.70.44:18080/risk/',
		// 		'http://120.86.70.44:18080/digital/',
		// 		'http://120.86.70.44:18080/open_fund/'],
		// 生产环境
		// netUrl:
		// 	['https://bh.htsec.com/otc/',
		// 		'https://bh.htsec.com/risk/',
		// 		'https://bh.htsec.com/digital/',
		// 		'https://bh.htsec.com/open_fund/'],
		netUrl: process.env.NETURL
	}
}



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 5